import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationCenterActionType, NotificationCenterMessageView } from '@fgb/core';

@Component({
  selector: 'fgbcl-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
})
export class NotificationItemComponent implements OnInit {
  @Input() notification: NotificationCenterMessageView;
  @Input() isNotificationToaster: boolean = false;
  @Output() goToNotification = new EventEmitter();
  @Output() removeNotification = new EventEmitter();
  actionType = NotificationCenterActionType;
  timer$: Observable<string>;
  id: number = 1;

  constructor() {}

  ngOnInit() {}
}
